import { useState, useEffect, useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography, Box, Accordion, AccordionSummary } from "@mui/material";
import "./GuestVerification.css";

const GuestVerification = () => {
  const [expanded, setExpanded] = useState("panel0");
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);
  const lastTimeRef = useRef(Date.now());
  const remainingTimeRef = useRef(8000); // Default time

  const accordionData = [
    {
      title: "Account Validation",
      content:
        "When guests sign up on the Rentid platform, we validate their email and phone number through our security system to ensure trust and safety.",
      image: "/img/RentID/guestVerificatioRight_1.webp",
    },
    {
      title: "Driver’s License Validation",
      content:
        "Verify driver’s licenses against official databases while analyzing document integrity to detect tampering, forgery, or altered documents.",
      image: "/img/RentID/guestVerificatioRight_2.webp",
    },
    {
      title: "Biometric Verification",
      content:
        "Automated AI facial recognition and biometric analysis ensure renters are accurately matched with their identification documents.",
      image: "/img/RentID/guestVerificatioRight_3.webp",
    },
    {
      title: "Identity Cross-Referencing",
      content:
        "Cross-check renter information against multiple authoritative databases and registries to identify red flags.",
      image: "/img/RentID/guestVerificatioRight_4.webp",
    },
    {
      title: "Guest Risk Indicators",
      content:
        "Simple to understand data-based insights to assist in risk decision making.",
      image: "/img/RentID/guestVerificatioRight_5.webp",
    },
  ];

  const switchTab = () => {
    setExpanded((prev) => {
      const currentIndex = accordionData.findIndex((_, i) => `panel${i}` === prev);
      const nextIndex = (currentIndex + 1) % accordionData.length;
      return `panel${nextIndex}`;
    });

    lastTimeRef.current = Date.now(); // Reset last execution time
    remainingTimeRef.current = 5000; // Reset interval
  };

  useEffect(() => {
    if (isPaused) return;

    intervalRef.current = setTimeout(switchTab, remainingTimeRef.current);

    return () => clearTimeout(intervalRef.current);
  }, [expanded, isPaused]);

  const handleMouseEnter = () => {
    if (!isPaused) {
      clearTimeout(intervalRef.current);
      remainingTimeRef.current -= Date.now() - lastTimeRef.current; // Store remaining time
      setIsPaused(true);
    }
  };

  const handleMouseLeave = () => {
    lastTimeRef.current = Date.now();
    setIsPaused(false); // Resume smoothly
  };

  return (
    <section className="guestVerificationMain" id="guestverification">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="headGuestVerification">
              <h2>
                Realtime <span>Guest Verification</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4">
            <div className="guestVerificationLeft">
              <img className="img-fluid new" src="/img/rentid_logo_icon.svg" alt="icon" />
              <h3>Instant, Accurate Trust and Safety Tools</h3>
              <p>
                Verify guests effortlessly with our multi-layered tech. Swiftly confirm identities and reduce fraud risk,
                ensuring fleet security with cutting-edge verification.
              </p>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="row">
              <div className="col-lg-6 col-sm-6">
                <div className="guestVerificationMiddle" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                  {accordionData.map((accordion, index) => (
                    <Box key={index} className="boxAccordian">
                      <Accordion
                        className="headingAccordian"
                        expanded={expanded === `panel${index}`}
                        onChange={() => setExpanded(`panel${index}`)}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography>{accordion.title}</Typography>
                        </AccordionSummary>
                      </Accordion>
                      {expanded === `panel${index}` && (
                        <Box className="summaryAccordian">
                          <Typography>{accordion.content}</Typography>
                        </Box>
                      )}
                    </Box>
                  ))}
                </div>
              </div>
              <div className="col-lg-6 col-sm-6">
                <div className="guestVerificatioRight">
                  {accordionData.map((accordion, index) =>
                    expanded === `panel${index}` ? (
                      <Box key={index} sx={{ textAlign: "center" }}>
                        <img src={accordion.image} alt={`${accordion.title}`} />
                      </Box>
                    ) : null
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuestVerification;
